import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import PropertygroupsEditForm from './PropertygroupsEditForm';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchPropertygroup } from 'store/actions/propertygroups/fetchPropertygroups';
import { updatePropertygroup } from 'store/actions/propertygroups/updatePropertygroups';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import fetchResourceAndLocalisationById from 'components/hoc/fetchResourceAndLocalisationById';

class PropertygroupsEditContainer extends React.Component {
    formatFormResults = (values) => {
        const {
            system,
        } = this.context.config.language;

        let baseValues = {
            ...values.localisation[system],
        };

        const localisationValues = utils.filterEmptyValues(values.localisation);

        return {
            base: baseValues,
            localisation: localisationValues,
        };
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        const convertedValues = this.formatFormResults(values);

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: () => {
                    reject();
                },
                onSuccess: () => {
                    resolve(history.push(`/propertygroups/${ id }/show`));
                },
                formValues: convertedValues,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            localisation,
            resourceFetchLoading,
            resourceFetchFailed,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.propertygroups.plural'),
                link: '/propertygroups',
            },
            {
                label: data.name,
                link: `/propertygroups/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.propertygroups.actions.edit', { title: data.name }) } />

                    <Actions>
                        <ListButton url='/propertygroups' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <PropertygroupsEditForm
                            form='property_gruops_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                            localisation={ localisation }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

PropertygroupsEditContainer.contextTypes = {
    config: PropTypes.object,
};

PropertygroupsEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object,
    id: PropTypes.number,
    localisation: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updatePropertygroup(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceAndLocalisationById({
        action: fetchPropertygroup,
        resource: 'propertygroups',
    })
);

export default enhance(PropertygroupsEditContainer);



// WEBPACK FOOTER //
// ./src/pages/propertygroups/edit/PropertygroupsEditContainer.js